import Repository from '@/repositories/repository'

const GlobalSeoRepository = {
  async getAllMarketsHolidays(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '200',
      ...queryParams
    }

    return await Repository('holiday-calendar', 'page', params)
  }
}

export default GlobalSeoRepository
